import React, { RefObject } from 'react';
import { useFocus } from '../helpers/useFocus';

interface ColorProps {
  active: boolean;
  onClick: () => void;
  color: string;
  style?: React.CSSProperties;
}

interface ColorsProps {
  selectedColor: string | null;
  colors: string[];
  onSelectColor: (color: string) => void;
}

const Color: React.FunctionComponent<ColorProps> = ({
  color,
  active,
  onClick,
  style,
}) => {
  const [focusRef, isFocused] = useFocus();

  return (
    <button
      ref={focusRef as RefObject<HTMLButtonElement>}
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: color,
        marginBottom: '12px',
        cursor: 'pointer',
        border: '1px solid',
        outline: 'none',
        borderColor: active || isFocused ?
          `${Theme['@black']}`
          : color === '#FAFBFB'
            ? `${Theme['@grey-light']}`
            : 'transparent',
        ...style,
      }}
      key={color}
      onClick={onClick}
    />
  );
};

const Colors: React.FunctionComponent<ColorsProps> = ({
  colors,
  selectedColor,
  onSelectColor,
}) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {colors.map((color, i) => (
        <Color
          color={color}
          active={color === selectedColor}
          style={{
            marginRight: i + 1 === colors.length ? '0' : '12px',
          }}
          onClick={() => onSelectColor(color)}
          key={color}
        />
      ))}
    </div>
  );
};

export default Colors;
